import { makeStyles } from "@material-ui/core/styles";
import BannerImage from "../../../assets/images/img-otros-plan.png";

const styles = makeStyles(theme => ({
  titleSectionContainer: {
    padding: "60px 16% 45px 16%",
    [theme.breakpoints.down("md")]: {
      padding: "40px"
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "0",
      padding: "10px"
    }
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse"
    }
  },
  titleText: {
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    flex: 1,
    maxWidth: "200px",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      width: "100%",
      justifyContent: "left",
      marginTop: "20px"
    }
  },
  titleSection: {
    fontSize: "24px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "1.1",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "440px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "24px"
    }
  },

  lineTitle: {
    borderLeft: "10px solid #0073cf",
    height: "50px",
    marginRight: "15px"
  },
  buttonContainer: {
    width: "200px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #00b9e4",
    borderRadius: "5px",
    textDecoration: "none",
    color: "#0073cf",
    [theme.breakpoints.down("sm")]: {
      width: "140px",
      textAlign: "center"
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: "5px",
      marginRight: "5px",
      marginTop: "15px",
      width: "95px",
      fontSize: "14px",
      fontWeight: "bold",
      flex: 1
    }
  },
  containerButtons: {
    display: "flex",
    marginLeft: "40px",
    justifyContent: "space-evenly",
    flex: "1",
    maxWidth: "720px",
    [theme.breakpoints.down("lg")]: {
      maxWidth: "650px",
      marginLeft: "25px"
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px"
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: "unset",
      // maxWidth: "310px",
      width: "100%"
    }
  }
  // "@media (min-width: 960px)": {
  //   content: {
  //     display: "flex"
  //   }
  // }
}));

export default styles;
